<template>
  <div>
    <b-row class="float-right mb-3" >
      <span>Exibir</span>
      <select class="ml-2" v-model="rowsPerPage">
        <option 
          v-for="pageSize in pageSizeMenu"
          :value="pageSize"
          v-bind:key="pageSize" 
        >
          {{ pageSize }}
        </option>
      </select>
      <span class="ml-2 mr-3">Linhas</span>
    </b-row>
    
    <b-row> 
      <p class="mr-3">
        Débitos(s)
      </p>
    </b-row>

    <div>
    <b-table
      responsive
      stacked="md"      
      :bordered="false"
      select-mode="multi"      
      striped
      hover
      :sort-by.sync="sortBy"      
      :small="true"
      :items="items"
      :fields="fields"
      :per-page="rowsPerPage"
      :current-page="currentPage"
      :tbody-tr-class="rowClass"      
      show-empty
      empty-text="Tente novamente mais tarde. Erro inesperado na rotina de lançamentosSelecionados."
      summary="Tabela de Débitos"
      primary-key="id"
    >
      <template #head(ESTADO_LANCAMENTO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary'}" 
          title="
           <strong>ATIVO:</strong> Débito ativo é o saldo devedor exigível.<br/><br/>
           <strong>SUSPENSO:</strong> Débito com exigibilidade suspensa por reclamação administrativa ou judicial.<br/><br/>
            <strong>ENVIADO PROTESTO:</strong> Emissão de DRAM somente no cartório. Emitir relatório de débitos protestados.<br/>"
           >
          Situação
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #head(DESCRICAO_LANCAMENTO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary'}" 
          title="Passe o mouse sobre cada descrição para ver mais detalhes">
          Descrição Débito
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>      

      <template #cell(DESCRICAO_LANCAMENTO)="{ item }">
        <p v-b-tooltip.hover.left :title="item.DSC_TOOLTIP">
          {{ item.DESCRICAO_LANCAMENTO }}
        </p>
      </template>

      <template #head(IND_INSCRITO)="item">
        <div class="a" style="width: 80px">
          <span>{{ item.label }}</span>
        </div>
      </template>

      <template #head(IND_PRESCRITO)>
        <span
          v-b-tooltip.hover.html="{ variant: 'primary' }"
          title="Passe o mouse sobre 'sim' para ver o procedimento para solicitar quitação administrativa"
        >
          Prescrito
          <b-icon variant="primary" icon="info-circle-fill" />
        </span>
      </template>

      <template #cell(IND_PRESCRITO)="{ item }">
        <div v-if="item.IND_PRESCRITO === 'sim'">
          <a
            :href="link"
            target="_blank"
            data-toggle="tooltip"
            data-placement="bottom"
            v-b-tooltip.hover.left
            :title="tooltipPrescrito"
          >
           <strong><em>{{ item.IND_PRESCRITO }}</em></strong></a
          >
        </div>
        <div v-else>
          <p>
            {{ item.IND_PRESCRITO }}
          </p>
        </div>
      </template>

       <template #head(NUMERO_PARCELAMENTO)="item">
        <div class="a" style="width: 100px">
          <span>{{ item.label }}</span>
        </div>
      </template>  

      <template #cell(PAGAMENTO_VISTA)="{ item }">
        {{
          formatCurrency(
            item.VALOR_SIMPLES +
              item.VALOR_CORRECAO +
              item.VALOR_MULTA +
              item.VALOR_JUROS +
              item.VALOR_HONORARIO -
              (item.VALOR_DESCONTO + item.VALOR_DESC_HONORARIO)
          )
        }}
      </template>
    </b-table>
    </div>

    <b-row class="d-flex justify-content-between mx-3">
      <b-col>
        <b>Total de registros: {{ items.length }}</b>
        <br />
        Página {{ currentPage }} de
        {{ Math.ceil(items.length / rowsPerPage) }}
      </b-col>
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="rowsPerPage"
        aria-controls="my-table"  
        align="right"
      >
      </b-pagination>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    items: Array,
    fields: Array,
    title: String,
  },
  data() {
    return {
      rowsPerPage: 5,
      pageSizeMenu: [5, 10, 20, 50, 100, 200],
      currentPage: 1,
      ordenarPor: "",
      sortBy: "ID_CATEGORIA_PARCTO",
      ordenacaoDecrescente: false,
      ordenacaoDirecao: "asc",

      link: "https://servicos.pbh.gov.br/servicos/i/5e82412ed9521a26a95515af/5dc8470253fd6b5bbd99185f/servicos+divida-ativa-prescricao-de-debitos-inscritos",
      tooltipPrescrito:
        'Para solicitar o cancelamento do débito, acessar o Portal de Serviços da PBH, clicando no ' + ' " '+ 'sim' + ' " ',
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  methods: {
    formatCurrency: function (value) {
      let formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      });
      return formatter.format(value);
    },
 
    //  destacar uma linha na tabela  //
    rowClass(item, type) {
        if (!item || type !== 'row') {
          return '';
        }
        if (item.ID_CATEGORIA_PARCTO === 9) {
          return 'table-warning'
        }
        return '';
      },
    //      
  },
};
</script>
